module.exports = __webpack_public_path__ + "static/img/dalou.412abda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dalou.png
// module id = /Ntc
// module chunks = 16